import _ from "lodash";
import FilterObject from "./filterObject.js";
//le processorObject a des filtres qu'on ajoute avec addFilter et qui sont appliqués à la suite quand on exécute process
export default class ProcessorObject {
    constructor(type) {
        this.type = type;
        this.filters = [];
        this.messages = [];
    }
    addFilter(condition, action, reason) {
        this.filters.push(new FilterObject(condition, action, this.type, reason));
    }
    process(weekArray) {
        return this.filters.reduce((resultArray, filter) => {
            const result = filter.process(resultArray);
            this.messages.push(...filter.getMessages());
            return result;
        }, weekArray);
    }
    getMessages() {
        return _.uniq(_.flatten(this.messages));
    }
}
//# sourceMappingURL=processorObject.js.map